import React from 'react';
import {getIntroCardImageSrc} from 'common/utils/statics-util';
import {t} from 'common/utils/translation-util';

export default class ZeroCard extends React.Component {
  render() {
    return (
      <div className={'clearfix IntroCard--horizontal'}>
        <img src={getIntroCardImageSrc('Dashboard-no-data.svg')} />
        <p>{t('Server error.')}</p>
      </div>
    );
  }
}
